import { Command } from '../../../../../core/command/Command.js';
export class ConnectCommandResponse {
    constructor(payload, walletType) {
        this.payload = payload;
        this.walletType = walletType;
    }
}
export class ConnectCommand extends Command {
    constructor(environment, wallet, account, custodialSettings) {
        super();
        this.environment = environment;
        this.wallet = wallet;
        this.account = account;
        this.custodialSettings = custodialSettings;
    }
}
